import * as React from 'react'
import { Theme } from '@mui/material/styles'
import { FC } from 'react'
import { Form, useFormikContext } from 'formik'

import { EditOpportunityNameFormModel } from './EditOpportunityNameFormWrapper'

import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { OpportunityName } from '@user/components/Opportunities/OpportunityName/OpportunityName'
import { ILeadOppProduct } from '@user/store/leadOppProducts/typings'

interface Props {
  initialValue: string
  onCancel: () => void
  services: ILeadOppProduct[]
}

const styles = {
  root: {
    width: '450px',
  },

  input: {
    display: 'flex',
  },

  submitBtn: {
    marginLeft: (theme: Theme) => theme.spacing(1),
  },
}

export const EditOpportunityNameFormFields: FC<Props> = (props: Props) => {
  const { initialValue, onCancel, services } = props

  const { dirty, isValid, isSubmitting } =
    useFormikContext<EditOpportunityNameFormModel>()

  return (
    <Form autoComplete="off">
      <Box sx={styles.root}>
        <Typography>
          <b>Rename this Opportunity</b> (Name Must Be Unique)
        </Typography>

        <Box mt={2}>
          <OpportunityName
            disabled={isSubmitting}
            initialValue={initialValue}
            services={services}
          />
        </Box>

        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button
            data-test-id="cancel-btn"
            onClick={onCancel}
            variant="outlined"
          >
            Cancel
          </Button>

          <Button
            sx={styles.submitBtn}
            data-test-id="save-btn"
            color="primary"
            disabled={!dirty || isSubmitting || !isValid}
            type="submit"
            variant="contained"
          >
            Save
          </Button>
        </Box>
      </Box>
    </Form>
  )
}

EditOpportunityNameFormFields.displayName = 'EditOpportunityNameFormFields'
